import React from "react";
import List from "@commonComponents/List";
import ContainerTabForm from "@EUForms/containerTabForm";
import { containerTabActions } from "../../reducer/containerSlice";
import RepeatableSealNumber from "@EUForms/containers/repeatableSealNumber";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";
import MarkedDeleted from "../items/markedDeleted";
import { useDispatch } from "react-redux";



const ContainerDetails = ({ dataSource, saveItem, updateContainerHierarchy, ...rest }) => {
  const dispatch = useDispatch()
  const { isRFI, isRFIDisabled } = useCurrentShipmentType()
  const onMarkContainerDelete = (data, { id, tableName }) => {
    if (data.checked) {
      dispatch(updateContainerHierarchy({ containerId: id, data: { markDelete: '1' } }))
      saveItem(tableName, { id, markDelete: '1' })
    } else {
      dispatch(updateContainerHierarchy({ containerId: id, data: { markDelete: '0' } }))
      saveItem(tableName, { id, markDelete: '0' })
    }
  }
  const renderItem = (item) => {
    const isContainerDisabled = (isRFI && item?.markDelete == '1')
    return <ContainerTabForm
      dataSource={item}
      key={item.id}
      repeatableSealNumber={<RepeatableSealNumber
        containerId={item?.id}
        sealsList={item?.sealsList}
        containerTabActions={containerTabActions}
        isRFI={isRFI}
        isContainerDisabled={isContainerDisabled}
      />}
      markedDeleted={isRFI ? (params) => <MarkedDeleted
        label='_'
        className='marked-deleted marked-deleted-label-hidden'
        checked={(isContainerDisabled || false)}
        disabled={isRFIDisabled}
        onChange={
          (e, data) => onMarkContainerDelete(data, params)
        }
        style={{'input:checked ~ label': { color: 'transparent !important' }}}
      /> : null}
      isContainerDisabled={isContainerDisabled}
      {...rest}
    />
  }
  return <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem} />

}

export default ContainerDetails
